module.exports = __webpack_public_path__ + "static/img/lok-bin.3bb68b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lok-bin.jpg
// module id = gRZ0
// module chunks = 1